import type { ChairTypeOption } from './chairTypes';
import { SettingListSelect } from './SettingListSelect';

interface ChairTypeSelectProps {
  options: readonly ChairTypeOption[];
  /** The stored value, or null for not chosen. */
  value: string | null;
  onChange: (value: string | null) => void;
}

/**
 * The chair a table, row or block is set with, from the office's list
 * (Settings → App Settings → Chair Types).
 */
export function ChairTypeSelect({ options, value, onChange }: ChairTypeSelectProps) {
  return (
    <SettingListSelect
      options={options}
      value={value}
      onChange={onChange}
      label="Chair type"
      emptyMessage="No chair types yet — add them in Settings → App Settings"
      testId="chair-type-select"
    />
  );
}
